import "../App.css";
import "./Home.css";
import Carousel from "./Carousel.js";
import CarouselVideo from "./CarouselVideo.js";
import Categories from "./home/Categorieshome.js";
import MainCarousel from "./main-carousel/MainCarousel.js";
import Catalogue from "./home/Catalogo.js";
import Elevaespacio from "./home/Elevaespacio.js";

function Home({ catalogosection, instalacionsection }) {

  return (
    <>
      <section className="home-container">
        <section className="main-carousel">
          <MainCarousel />
        </section>

        <div className="home-container-carousel">
          <div className="description">
            <p>
              En Woodart, transformamos tus espacios con elegancia y versatilidad.
            </p>
            <p>
              Nuestra amplia gama de productos está diseñada para ofrecerte soluciones decorativas
            </p>
            <p>
              que combinan estética y funcionalidad,
              perfectas para cualquier ambiente.
            </p>
          </div>

          <Carousel />
        </div>

        <section className="section-home">
          <article className="section-title">
            <h2 className="title-line">COLECCIONES</h2>
            <div className="title-line-line"></div>
          </article>
          <Categories />
        </section>

        <section className="section-home">
          <Elevaespacio />
        </section>

        <section ref={instalacionsection} className="section-home">
          <article className="section-title">
            <h2 className="title-line">INSTALACIÓN</h2>
            <div className="title-line-line"></div>
          </article>
          <CarouselVideo></CarouselVideo>
        </section>

        <section ref={catalogosection} className="section-home">
          <Catalogue />
        </section>
      </section>
    </>
  );
}

export default Home;